import type { ImageTileCtaPiece } from "@workspace/crystallize/generated/discovery/";
import { cn } from "@workspace/ui/lib/utils";
import CrystallizeResponsiveImage from "../product/crystallize-responsive-image";

export default function ImageTileCta({
  title,
  text,
  images,
}: ImageTileCtaPiece) {
  const classMap = [
    "col-span-6",
    "col-span-6 md:col-span-4",
    "col-span-6 md:col-span-4",
    "col-span-6 md:col-span-4",
  ];

  return (
    <section className="overflow-hidden bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-6">
            <h2 className="font-medium text-4xl text-primary tracking-tight sm:text-5xl">
              {title}
            </h2>
            {text && (
              <div
                className="prose mt-6 text-base/7"
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <We are receiving html from Crystallize>
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </div>
          {images?.slice(0, 4).map((image, index) => (
            <div key={image?.key} className={classMap[index]}>
              <div
                className="overflow-hidden rounded-2xl"
                style={
                  image?.width && image?.height
                    ? { aspectRatio: `${image.width} / ${image.height}` }
                    : undefined
                }
              >
                <CrystallizeResponsiveImage
                  image={image ?? {}}
                  className="h-full w-full object-cover"
                  sizes={index === 0 ? "50vw" : "(max-width: 640px) 50vw, 33vw"}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
